<template>
    <div
        class="suggestList"
        v-show="suggestions.length > 0"
        :style="{width: width}"
        ref="suggestList"
        @click.stop
    >
        <span>Выберите вариант или продолжите ввод</span>
        <a v-for="(suggestion, i) in suggestions"
           :key="'sug_'+i"
           class="suggestList-item"
           :class="{'active' : selectedIndex === i}"
           @click.stop="selectSuggest(suggestion)"
           v-html="formatSuggestionValue(suggestion)"
        ></a>
    </div>
</template>
<script>
import {suggest} from "../../../../plugins/dadata";

export default {
    name: 'Suggest',
    emits: ['change', 'click', 'showSuggestions', 'fillValue', 'getParseFromDaData'],
    props: {
        value: Object,
        fieldName: String,
        keyBlock: String,
        type: {
            type: String,
            default: 'address',
        },
        width: String,
        disable: {
            type: Boolean,
            default: false
        },
        queryPattern: {
            type: String,
            default: '%s'
        },
        dataElementPrefix: {
            type:String,
            default: ''
        }
    },
    data() {
        return {
            lastSuggestions: null,
            suggestions: [],
            selectedSuggest: null,
            selectedIndex: null,
            inputEl: null,
            eventBinded: false,
            bindSuggest: [],
        };
    },
    methods: {
        focusHandler() {
            if (this.inputEl.readOnly || this.inputEl.disabled)
                return;
            this.$root.$el.dispatchEvent(new Event('click', {'bubbles': true, 'cancelable': false}));
            if (this.lastSuggestions && this.suggestions !== this.lastSuggestions) {
                this.suggestions = this.lastSuggestions
            }
        },
        keyDownHandler(e) {
            if (['ArrowDown', 'ArrowUp', 'Enter'].indexOf(e.key) > -1) {
                e.preventDefault();
                if (e.key === 'ArrowDown') {
                    this.selectedIndex = this.selectedIndex === null ? 0 : this.selectedIndex + 1;
                    if (this.suggestions.length <= this.selectedIndex) {
                        this.selectedIndex = 0;
                    }
                } else if (e.key === 'ArrowUp') {
                    this.selectedIndex = this.selectedIndex === null ? -1 : this.selectedIndex - 1;
                    if (this.selectedIndex < 0) {
                        this.selectedIndex = this.suggestions.length - 1;
                    }
                }
                if (e.key !== 'Enter') {
                    this.selectedSuggest = this.suggestions[this.selectedIndex];
                } else {
                    this.selectSuggest(this.suggestions[this.selectedIndex]);
                }

            }
        },
        rootClickHandler(e) {
            if (e.target !== this.inputEl) {
                this.suggestions = [];
            }
        },
        selectSuggest(suggestion) {
            this.selectedSuggest = suggestion;
            this.suggestions = [];

            this.$emit('getParseFromDaData', this.keyBlock, suggestion.data);
        },
        showSuggest(value) {
            if (this.inputTimeout) {
                clearTimeout(this.inputTimeout);
            }
            if (this.queryPattern) {
                value = this.queryPattern.replace('%s', value);
            }
            this.inputTimeout = setTimeout(() => {
                suggest(this.type, value).then((r) => {
                    this.$root.$el.dispatchEvent(new Event('click', {'bubbles': true, 'cancelable': false}));
                    this.selectedIndex = null;
                    if (r) {
                        if (!this.disable) {
                            this.suggestions = r.suggestions;
                            this.$emit('showSuggestions', r.suggestions);
                        }
                        this.lastSuggestions = r.suggestions;
                        if (!this.eventBinded) {
                            this.inputEl.addEventListener('focus', this.focusHandler);
                            this.inputEl.addEventListener('keydown', this.keyDownHandler);
                            this.eventBinded = true;
                        }
                    }
                });
            }, 600);
        },
        formatSuggestionValue(suggestion) {
            let result = this.highlight(suggestion.value) + ' <br/>';
            if (this.type === 'party') {
                result += '<small>' + this.highlight(suggestion.data.inn) +
                    (suggestion.data.address ? ', ' + this.highlight(suggestion.data.address.value) : '') +
                    '</small>';
            }
            if (this.type === 'bank') {
                result += '<small>' + this.highlight(suggestion.data.bic) +
                    (suggestion.data.address ? ', ' + this.highlight(suggestion.data.address.value) : '') +
                    '</small>'
            }

            return result;
        },
        highlight(string) {
            let trigger = this.inputEl.value.replace(/<\/?small>|<\/?b>|<br\/?>|[<>]|br|b|small|r|^\/+/g, "").trim();
            if (trigger) {
                trigger = trigger.split(' ');
                trigger.forEach((str) => {
                    if (str !== '/') {
                        string = string.replaceAll(str, '<b>' + str + '</b>');
                        str = str.substr(0, 1).toUpperCase() + str.substr(1);
                        string = string.replaceAll(str, '<b>' + str + '</b>');
                    }
                });
            }

            return string;
        },
    },

    mounted() {
        this.inputEl = document.querySelector('[name="' + this.fieldName + '"]');
        this.inputEl.autocomplete = 'off';

        this.inputEl.addEventListener('input', (event) => {
            let val = event.target.value;
            if (!val) {
                this.selectedSuggest = null;
                this.suggestions = [];
                this.lastSuggestions = [];
            }

            this.showSuggest(val);
        });

        if (this.bindSuggest.indexOf(this.inputEl) === -1) {
          this.bindSuggest.push(this.inputEl)
          this.$root.$el.addEventListener('click', this.rootClickHandler);
        }
    }
};
</script>

<style lang="scss">
.suggestList {
    position: absolute;
    z-index: 20;
    background: #fff;
    overflow: auto;
    box-shadow: 0 3px 14px rgba(55, 71, 79, 0.3);
    left: 0;
    right: 0;
    margin: 0 7px;
    min-width: 545px;
    @media screen and (max-width: 499px) {
        min-width: 295px;
    }

    &-item {
        cursor: pointer;

        b {
            color: #03A9F4;
            font-weight: 300;
        }
    }

    span {
        font-size: 0.8rem;
        color: #607D8BFF;
        padding: 0 15px;
    }

    a {
        cursor: pointer;
        display: block;
        padding: 0 15px;
        overflow: hidden;
        text-decoration: none;
        color: #37474F;

        &:hover, &.active {
            color: #37474F;
            background-color: #E5EDF3;
        }
    }
}
</style>